/** 
 * @type {CountriesFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: [],
    codes: null,
    names: null,
}
/** 
* @returns {CountriesFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/CountriesFilter.js